import React from "react";
import {useNavigate} from "react-router-dom";
import {ReportItemData} from "../../../../types/demo";


interface Props {
    item: ReportItemData;
    isFavorite: boolean;
    onToggleFavorite: (item: ReportItemData) => void;
    showGroup?: boolean;
}

const ReportItem = ({ item, isFavorite, onToggleFavorite, showGroup }: Props) => {
    const navigate = useNavigate()

    return (
        <div className="flex align-items-center justify-content-between py-2 border-bottom-1 border-200 cursor-pointer transition-colors transition-duration-150">
            <div className="ml-2" onClick={(e) => {
                e.stopPropagation()
                navigate(item?.navigateTo)
            }}>
                <span className="text-700 hover:text-primary font-medium">{item.label}</span>
                {showGroup && (
                    <span className="text-400 text-sm ml-2 italic">({item?.module}/{item?.type})</span>
                )}
            </div>
            <i
                className={`pi ${isFavorite ? 'pi-star-fill text-primary' : 'pi-star text-400'} hover:text-primary mr-2`}
                style={{ fontSize: '1rem' }}
                onClick={(e) => {
                    e.stopPropagation();
                    onToggleFavorite(item);
                }}
            ></i>
        </div>
    );
};

export default ReportItem;